import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const trio = [
    {
        slug: "rob-burton",
        municipality: "Oakville",
        name: "Rob Burton",
        headline: "Two Decades of Municipal Leadership",
        text: "Rob Burton became Oakville's mayor in 2006 and is campaigning on his record of long-term municipal leadership. His published priorities include managing growth responsibly, protecting established neighbourhoods and green spaces, maintaining strong municipal finances, and investing in community facilities. His campaign emphasizes experience, continuity and results as Oakville plans its next chapter.",
    },
    {
        slug: "marianne-meed-ward",
        municipality: "Burlington",
        name: "Marianne Meed Ward",
        headline: "Community Voice, Growth and Getting Things Done",
        text: "Marianne Meed Ward became Burlington's mayor in 2018 after serving as a councillor and community advocate. Her campaign highlights resident engagement, responsible development, traffic and transit improvements, public safety, and protecting Burlington's waterfront and green spaces. Her published platform also proposes costed budget options, affordability measures and improved congestion management.",
    },
    {
        slug: "jason-brass",
        municipality: "Halton Hills",
        name: "Jason Brass",
        headline: "Protecting Our Future, Honouring Our Past",
        text: "Jason Brass is a Halton Hills councillor, local business owner and lifelong resident running for mayor. His campaign focuses on ensuring infrastructure keeps pace with growth, responsible spending, community safety, expanded recreation opportunities, and protecting farmland, heritage and the distinctive character of the town's hamlets. He presents open communication, accountability and resident involvement as central to his approach.",
    },
];

export const FeaturedProfiles = () => (
    <section className="border-b border-border bg-ivory" aria-labelledby="more-featured-heading" data-testid="featured-profiles-section">
        <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-teal">
                    Featured Profiles
                </p>
                <h2 id="more-featured-heading" className="mt-4 font-serif-display text-2xl font-semibold text-navy sm:text-3xl">
                    More candidates shaping the 2026 races
                </h2>
            </Reveal>
            <div className="mt-8 grid gap-5 md:grid-cols-3">
                {trio.map((f, i) => (
                    <Reveal key={f.slug} delay={i * 0.08} className="h-full">
                        <article
                            className="flex h-full flex-col border border-border bg-white p-6"
                            data-testid={`featured-card-${f.slug}`}
                        >
                            <div className="flex items-center justify-between">
                                <p className="text-xs font-semibold uppercase tracking-widest text-teal">
                                    {f.municipality}
                                </p>
                                <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
                            </div>
                            <h3 className="mt-3 font-serif-display text-xl font-semibold leading-snug text-navy">
                                {f.headline}
                            </h3>
                            <p className="mt-1 font-serif-display text-sm italic text-muted-foreground">
                                {f.name}
                            </p>
                            <p className="mt-4 text-sm leading-relaxed text-foreground/90">{f.text}</p>
                            <motion.span whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} className="mt-auto inline-block pt-6">
                                <Link
                                    to={`/candidates/${f.slug}`}
                                    data-testid={`featured-link-${f.slug}`}
                                    className="inline-flex items-center gap-2 bg-navy px-5 py-2.5 text-sm font-semibold text-ivory transition-colors hover:bg-teal"
                                >
                                    Read the featured profile
                                    <ArrowRight className="h-4 w-4" aria-hidden="true" />
                                </Link>
                            </motion.span>
                            <p className="mt-4 text-xs text-muted-foreground">
                                A selected editorial feature — not an official ranking or endorsement.
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
